"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLOSED = exports.DISCHARGED = exports.DISMISSED = exports.FILED_WARNING = exports.FILED = exports.REVIEW_FINISHED = exports.REVIEW_STARTED = exports.READY_FOR_REVIEW = exports.INTERVIEW_FINISHED = exports.INTERVIEW_STARTED = exports.INTAKE = void 0;
exports.INTAKE = "intake";
exports.INTERVIEW_STARTED = "interviewStarted";
exports.INTERVIEW_FINISHED = "interviewFinished";
exports.READY_FOR_REVIEW = "readyForReview";
exports.REVIEW_STARTED = "reviewStarted";
exports.REVIEW_FINISHED = "reviewFinished";
exports.FILED = "filed";
exports.FILED_WARNING = "filedWarning";
exports.DISMISSED = "dismissed";
exports.DISCHARGED = "discharged";
exports.CLOSED = "closed";